// @flow
import React, {Component} from 'react';
import styled, {css} from 'styled-components';

import {Controller, Scene} from 'react-scrollmagic';
import {graphql, StaticQuery} from "gatsby";
import {media} from "utils/Media"
import SwipeScene from "components/shared/SwipeScene"
import ButtonSwipe from "components/shared/ButtonSwipe"
import CopyBox from "components/shared/CopyBox"
import BgImage from 'components/shared/BgImage'

const Wrapper = styled.div`
    overflow: hidden;
    position: relative;

 .scrollmagic-pin-spacer {
    display: none !important;

    ${props => props.active && css`
        display: block !important;
    `}


    @media screen and (max-width: ${props => props.theme.sizes.sm}) {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    @media ${media.sm} {
        display: block !important;
    }
  }
  
  .sticky, .sticky2 { 
    height: 0;
    overflow: hidden;
    width: 100% !important;
    background: #000;
    
    ${props => props.active && css`
        height: 100vh;
    `}
    
    @media ${media.sm} {
        height: 100vh;
    }
  }
  
  .fs {
        height: 100vh;
    }
    
  .slideInUp {
        .no-touch & {
            visibility: hidden;
            opacity: 0;
            transition: all 0.7s ease-out;
            transform: translate3d(0, 50px, 0);
        }
        .no-touch .is-active & {
            visibility: visible;
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }
    
    .pinContainer {
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
    }
`;

class Costumes3 extends Component {

    displayMobile1 = (progress) => {
        return (
            <div className="sticky2">

                <BgImage
                    data={this.props.data}
                    play={progress > 0}
                    progress={progress}
                    noTitleBar
                />

                <ButtonSwipe
                    target={this.costumes31Swipe}
                    play={true}
                />

                <SwipeScene
                    ref={costumes31Swipe => this.costumes31Swipe = costumes31Swipe}
                    bgImageSm={this.props.data.bgStep1Sm.childImageSharp.gatsbyImageData}
                    bgImageMd={this.props.data.bgStep1Md.childImageSharp.gatsbyImageData}
                    bgImageLg={this.props.data.bgStep1Lg.childImageSharp.gatsbyImageData}
                    bgImageXl={this.props.data.bgStep1.childImageSharp.gatsbyImageData}
                    changeBg={false}
                    copyHorizontalPosition="toRight"
                    copyHorizontalPositionMd="toRight"
                    copyVerticalPositionMd="toTop"
                    copyMdWidth="narrow"
                    text="<h3>Mufasa</h3>
                    <p>The shape of his mask connects to the circle motif, central to the production Symmetrical makeup shows he is balanced.</p>
                    <p>His broad collar emphasises his strength.</p>
                    <p>Mufasa’s braids, red makeup, beaded corset and swords are inspired by the Maasai tribe.</p>"
                />

                

            </div>
        )
    }

    displayMobile2 = (progress) => {

        return (
            <div className="sticky2">

                <BgImage
                    data={this.props.data}
                    overrideDefaultImage={true}
                    play={progress > 0}
                    progress={progress}
                    noTitleBar
                />

                <ButtonSwipe
                    target={this.costumes3Swipe}
                    play={true}
                />

                <SwipeScene
                    ref={costumes3Swipe => this.costumes3Swipe = costumes3Swipe}
                    bgImageSm={this.props.data.bgStep2Sm.childImageSharp.gatsbyImageData}
                    bgImageMd={this.props.data.bgStep2Md.childImageSharp.gatsbyImageData}
                    bgImageLg={this.props.data.bgStep2Lg.childImageSharp.gatsbyImageData}
                    bgImageXl={this.props.data.bgStep2.childImageSharp.gatsbyImageData}
                    changeBg={false}
                    copyHorizontalPosition="toRight"
                    copyHorizontalPositionMd="toRight"
                    copyVerticalPositionMd="toTop"
                    copyMdWidth="narrow"
                    text="<h3>Scar</h3><p>A spikey mane protrudes from the top of his mask.</p><p>Scar’s arched, asymmetrical eyebrows show that he is imbalanced and cynical.</p><p>Bamboo on his costume exterior makes Scar appear skeletal and frail.</p><p>Scar’s silhouette is inspired by Japanese Samurai, he’s noble but can be ruthless.</p>"
                />

                

            </div>
        )
    }

    displayScene = (progress) => {
        return (
            <div className="sticky2">
                <BgImage
                    data={this.props.data}
                    play={progress > 0}
                    progress={progress}
                    noTitleBar
                />

                <ButtonSwipe
                    target={this.costumes3Swipe}
                    play={progress > 0}
                />

                <CopyBox
                    copyHorizontalPosition="toRight"
                    copyHorizontalPositionMd="toRight"
                    copyVerticalPositionMd="toTop"
                    copyMdWidth="narrow"
                    step1
                >
                    <h3>Mufasa</h3>
                    <p>The shape of his mask connects to the circle motif, central to the production Symmetrical makeup shows he is balanced.</p>
                    <p>His broad collar emphasises his strength.</p>
                    <p>Mufasa’s braids, red makeup, beaded corset and swords are inspired by the Maasai tribe.</p>
                </CopyBox>

                <SwipeScene
                    ref={costumes3Swipe => this.costumes3Swipe = costumes3Swipe}
                    bgImageSm={this.props.data.bgStep2Sm.childImageSharp.gatsbyImageData}
                    bgImageMd={this.props.data.bgStep2Md.childImageSharp.gatsbyImageData}
                    bgImageLg={this.props.data.bgStep2Lg.childImageSharp.gatsbyImageData}
                    bgImageXl={this.props.data.bgStep2.childImageSharp.gatsbyImageData}
                    copyHorizontalPosition="toRight"
                    copyHorizontalPositionMd="toRight"
                    copyVerticalPositionMd="toTop"
                    copyMdWidth="narrow"
                    text="<h3>Scar</h3><p>A spikey mane protrudes from the top of his mask.</p><p>Scar’s arched, asymmetrical eyebrows show that he is imbalanced and cynical.</p><p>Bamboo on his costume exterior makes Scar appear skeletal and frail.</p><p>Scar’s silhouette is inspired by Japanese Samurai, he’s noble but can be ruthless.</p>"
                />
            </div>
        )
    }

    render() {

        let mql = window.matchMedia(media.sm).matches;

        if (mql) {
            return (
                <Wrapper active={this.props.active} id="costumes3Wrapper">
                    <div id="costumes3Scene" ref={costumes3Scene => this.costumes3Scene = costumes3Scene}/>
                    <Controller>
                        <Scene
                            triggerElement="#costumes3Scene"
                            triggerHook="onLeave"
                            duration={500}
                            pin
                        >
                            {(progress) => this.displayScene(progress)}
                        </Scene>
                    </Controller>
                </Wrapper>
            )
        } else {
            return (
            <>
            <Wrapper active={this.props.active} id="costumes3Wrapper">
                <div id="costumes3Scene" ref={costumes3Scene => this.costumes3Scene = costumes3Scene} />
                <Controller>
                    <Scene
                        triggerElement="#costumes3Scene"
                        triggerHook="onLeave"
                        duration={3000}
                        pin
                        enabled={false}
                       
                    >
                        {(progress) => this.displayMobile1(progress)}
                    </Scene>
                </Controller>
            </Wrapper>   
            <Wrapper active={this.props.active} id="costumes3Wrapper1">
                <div id="costumes3Scene1" ref={costumes3Scene1 => this.costumes3Scene1 = costumes3Scene1} />
                <Controller>
                    <Scene
                        triggerElement="#costumes3Scene1"
                        triggerHook="onLeave"
                        duration={3000}
                        pin
                        enabled={false}
                        
                    >
                        {(progress) => this.displayMobile2(progress)}
                    </Scene>
                </Controller>
            </Wrapper>   
            </>
            )

        }
    }
}


export default (props) => (
    <StaticQuery
        query={graphql`
            query {
                 bgStep1: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-1-1920-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 1920, quality: 100)
                    }
                }
                
                bgStep1Lg: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-1-1440-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 1440, quality: 100)
                    }
                }
                
                bgStep1Md: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-1-991-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 991, quality: 100)
                    }
                }
                
                bgStep1Sm: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-1-576-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 575, quality: 100)
                    }
                }
                
               bgStep2: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-2-1920-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 1920, quality: 100)
                    }
                }
                
                bgStep2Lg: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-2-1440-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 1440, quality: 100)
                    }
                }
                
                bgStep2Md: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-2-991-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 991, quality: 100)
                    }
                }
                
                bgStep2Sm: file(relativePath: { eq: "Interactive/Production/lke-im-prod-pt7-2-576-min.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(width: 575, quality: 100)
                    }
                }
            }
		`}
        render={data => (
            <Costumes3 data={data} active={props.active} title={props.title}/>
        )}
    />
)
